module.exports = __webpack_public_path__ + "img/1475876033.3b519666.jpg";